// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Js_array from "rescript/lib/es6/js_array.js";
import * as Js_string from "rescript/lib/es6/js_string.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ReactRouterDom from "react-router-dom";
import * as JsxRuntime from "react/jsx-runtime";
import * as Title$BenfaerberBlog from "../components/Title.bs.js";
import * as Footer$BenfaerberBlog from "./Footer.bs.js";
import * as Header$BenfaerberBlog from "./Header.bs.js";
import * as Browser$BenfaerberBlog from "../wrappers/Browser.bs.js";
import * as Sidebar$BenfaerberBlog from "./Sidebar.bs.js";

function s(prim) {
  return prim;
}

function Body(props) {
  var match = ReactRouterDom.useLocation();
  var pathname = match.pathname;
  var isAbbreviation = function (word) {
    return Js_array.includes(word.toLowerCase(), [
                "json",
                "api",
                "css"
              ]);
  };
  React.useEffect((function () {
          window.scrollTo(0, 0);
          var prettyPathname = Js_array.joinWith(" ", Belt_Array.map(Js_string.split(" ", Js_string.replaceByRe(/-|\//g, " ", Js_string.sliceToEnd(1, pathname))), (function (w) {
                      if (isAbbreviation(w)) {
                        return w.toUpperCase();
                      } else {
                        return Js_string.slice(0, 1, w).toUpperCase() + Js_string.sliceToEnd(1, w);
                      }
                    })));
          Browser$BenfaerberBlog.$$Document.setTitle("What the Functor?" + (
                prettyPathname !== "" ? " - " + prettyPathname : ""
              ));
        }), [pathname]);
  return JsxRuntime.jsxs("main", {
              children: [
                JsxRuntime.jsx("title", {
                      children: "Home Page"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Title$BenfaerberBlog.make, {}),
                              className: "column is-one-fifth container-logo is-fullheight no-padding"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Header$BenfaerberBlog.make, {}),
                              className: "column is-four-fifths no-padding"
                            })
                      ],
                      className: "columns no-top-margin no-side-margin-mobile"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Sidebar$BenfaerberBlog.make, {}),
                              className: "column is-one-fifth container-sidebar no-padding gray is-fullheight is-hidden-mobile"
                            }),
                        JsxRuntime.jsx("div", {
                              children: props.children,
                              className: "column container-content no-padding"
                            }),
                        JsxRuntime.jsx("div", {
                              className: "column is-one-fifth is-desktop-only"
                            })
                      ],
                      className: "columns no-bottom-margin no-side-margin-mobile"
                    }),
                JsxRuntime.jsx(Footer$BenfaerberBlog.make, {})
              ],
              className: "main-content"
            });
}

var $$String;

var make = Body;

export {
  $$String ,
  s ,
  make ,
}
/* react Not a pure module */
